<template>
  <EditFormDialog
    :formData="addBrandForm"

    :formType="'add'"
    :loading="addBrandFormVisible"
    @submitForm="addBrandSubmit"
    @closeDialog="closeDialog"
    v-bind="$attrs"
    v-on="$listeners"
  >
<!--  <el-dialog title="新增/编辑品牌" :visible="addBrandFormVisible" :modal-append-to-body='false'>-->
<!--    <el-dialog title="新增/编辑品牌" :formType="'carBrandAdd'" :visible.sync="addBrandFormVisible" :modal-append-to-body='true'>-->
    <el-form :model="addBrandForm" :rules="rules" ref="addBrandForm" size="mini" class="edit_form">
      <el-form-item :label="$t('zi-mu-fen-lei')" :label-width="formLabelWidth" prop="type">
        <el-input :placeholder="$t('zui-duo-zhi-neng-shu-ru-yi-ge-zi-fu')" v-model="addBrandForm.type" clearable></el-input>
      </el-form-item>
      <el-form-item :label="$t('pin-pai')" :label-width="formLabelWidth" prop="brand">
        <el-input :placeholder="$t('pin-pai-0')" v-model="addBrandForm.brand" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="addBrandFormVisible = false">{{ $t('qu-xiao') }}</el-button>
      <el-button size="small" type="primary" @click.native="addBrandSubmit" :loading="addBrandSubmitLoading">{{ $t('que-ding') }}
      </el-button>
    </div>
<!--  </el-dialog>-->
  </EditFormDialog>
</template>

<script>
    import Pagination from "../../../../../components/Pagination";
    import carApi from "../../../api/carApi";
    import EditFormDialog from '@/components/EditFormDialog'
    import {validateInput,validatAlphabets} from '../../../../../common/validator'
    export default {
        name: "add",
        data() {
            return {
                views: {},
                enumData: [{
                    carTypeData: ''
                }],
                loading: false,
                inputVisible: false,
                inputValue: '',
                // restaurants: [],
                tableData: [{}],
                modelTableData: [{}],
                brandTableData: [{}],
                carSearchForm: {},
                modelSearchForm: {},
                brandSearchForm: {},
                listForSelectQuery: {},
                operatorForSelect: '',
                listForSelect: {},
                getCarsLoading: false,
                getBrandLoading: false,
                getModelsLoading: false,
                addForm: {},
                editForm: {},
                carsLoading: false,
                addModelForm: {},
                addBrandForm: {},
                editTypeForm: {},
                addSubmitLoading: false,
                editSubmitLoading: false,
                carModelLoading: false,
                addModelSubmitLoading: false,
                addBrandSubmitLoading: false,
                carBrandLoading: false,
                innerForm: {},
                searchTabsAddForm: {},
                addFormVisible: false,
                editFormVisible: false, // 外部对话框
                addModelFormVisible: false,
                addBrandFormVisible: false,
                viewVisible: false, // 视图
                multipleSelection: [],
                //activeName: 'carList',
                innerFormName: 'coordinate',
                viewName: 'detailForm',
                showFilters: true,
                input: '',
                val_time: '', // 创建时间
                formLabelWidth: '150px',
                // 分页参数
                pageparm: {
                    t: {},
                    currentPage: 1,
                    pageSize: 10,
                    total: 0
                },
                activeNames: ['basicInformation', 'addressInformation'],
                activeName: 'carList',
                rules:{
                  type: [
                    {required: true, message: this.$t('qing-tian-xie-zi-mu-fen-lei'), trigger: 'blur'},
                    {validator:function (rule, value, callback) {
                        validateInput(rule, value, callback,1,1,false,false,true,false,true,true,false)
                      }, required: true,trigger: 'blur'}
                    ],
                    brand: [
                        {validator: function (rule, value, callback) {
                                validateInput(rule, value, callback,0,10,true,true,false,true,true,false,false)
                            }, required: true,trigger: 'blur'}],

                }
            }
        },
        methods: {
            closeDialog(formType) {
              this.restForm()
              this.$refs["addBrandForm"].clearValidate()
              this.$emit("closeDialog", formType)
            },
            restForm() {
              this.addForm = {}
            },
            addBrandSubmit() {
              this.$refs["addBrandForm"].validate((valid) => {
                if (!valid) {
                  return ;
                } else {
                  carApi.checkDuplicateBrand(this.addBrandForm.brand).then((res)=>{
                    if (res.code === 0) {
                      if (res.data.length === 0) {
                        this.addBrandSubmitLoading = true
                        let param = JSON.stringify(this.addBrandForm)
                        carApi.saveOrUpdateBrand(param).then((res) => {
                          this.addBrandSubmitLoading = false
                          if (res.code === 0) {
                            this.addBrandForm = Object.assign({});
                            this.$message({
                              // message: res.message,
                              type: 'success',
                              message: this.$t('ti-jiao-cheng-gong')
                            });
                            this.addBrandFormVisible = false
                            this.$emit('afterAdd')
                            // this.submitBrandSearchForm()
                          } else {
                            this.$message.error(res.message)
                          }
                        })
                      } else {
                        this.$message.error(this.$t('che-liang-pin-pai-yi-tian-jia'))
                      }
                    } else {
                      this.$message.error(res.message)
                    }
                  })
                }
              });
            },
        },
        components: {
            Pagination,
            EditFormDialog
        },
        created: function () {

        },
        mounted: function () {


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/car/brand/add.vue